(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref400"];
var parcelRegister = parcelRequire.register;
parcelRegister("3ZHAa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e88e022d6806ee7$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");

var $6CdNF = parcelRequire("6CdNF");

var $5ZV7E = parcelRequire("5ZV7E");

var $f2oEI = parcelRequire("f2oEI");

var $3eaZI = parcelRequire("3eaZI");

var $hN5jq = parcelRequire("hN5jq");
var $2e88e022d6806ee7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $6CdNF._)(VariantPicker, HTMLElement1);
    var _super = (0, $3eaZI._)(VariantPicker);
    function VariantPicker() {
        (0, $J7ygF._)(this, VariantPicker);
        var _this;
        _this = _super.call(this);
        _this.optionLists = Array.from(_this.querySelectorAll(".option-list"));
        _this.staticOptionLists = _this.optionLists.filter(function(optionList) {
            return !optionList.classList.contains("dynamic-option");
        });
        _this.priceText = document.getElementById("price-text");
        _this.productInfo = document.querySelector(".product-info");
        _this.currentVariantId = document.getElementById("current_variant_id");
        // affirm text
        _this.affirmText = document.querySelector(".affirm-as-low-as");
        return _this;
    }
    (0, $hvJJn._)(VariantPicker, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this = this;
                // affirm
                affirm.ui.ready(function() {
                    affirm.ui.refresh();
                });
                // update static options
                if (this.staticOptionLists.length) this.updateStaticOptions(true);
                // handle logic for variant picker option lists
                this.optionLists.forEach(function(optionList) {
                    var radioButtons = Array.from(optionList.querySelectorAll('input[type="radio"]'));
                    var selectedItemEl = optionList.querySelector(".selected-item");
                    var optionImage = optionList.querySelector(".clicker img");
                    // add different listeners for dynamic/static options
                    if (optionList.classList.contains("dynamic-option")) radioButtons.forEach(function(radioButton) {
                        radioButton.addEventListener("change", function() {
                            // remove no-selection-made class
                            optionList.classList.remove("no-selection-made");
                            _this.productInfo.classList.add("loading");
                            // update selected item text
                            selectedItemEl.innerHTML = radioButton.value;
                            // get the new variant
                            var newVariantId = radioButton.dataset.variantId;
                            // update url
                            var newUrl = _this.generateUrl({
                                data: {
                                    key: "variant",
                                    value: newVariantId
                                }
                            });
                            history.pushState(null, "", newUrl);
                            // build url for section fetch
                            var sectionUrl = "".concat(window.location.pathname, "?section_id=main-product&variant=").concat(newVariantId);
                            // fetch the section
                            _this.renderPage({
                                url: sectionUrl,
                                updateOptions: false
                            });
                        });
                        radioButtons.forEach(function(radioButton) {
                            radioButton.addEventListener("click", function() {
                                // remove no-selection-made class
                                optionList.classList.remove("no-selection-made");
                            });
                        });
                    });
                    else radioButtons.forEach(function(radioButton) {
                        radioButton.addEventListener("change", function() {
                            // remove no-selection-made class
                            optionList.classList.remove("no-selection-made");
                            // get radio button name
                            var name = radioButton.name;
                            // remove 'static-option:' from name
                            name = name.replace("static-option:", "");
                            // then slugify the name
                            name = (0, (/*@__PURE__*/$parcel$interopDefault($hN5jq)))(name, {
                                lower: true
                            });
                            // update selected item text
                            selectedItemEl.innerHTML = radioButton.value;
                            // turn radio button value to a slug
                            var value = (0, (/*@__PURE__*/$parcel$interopDefault($hN5jq)))(radioButton.value, {
                                lower: true
                            });
                            // update url
                            var newUrl = _this.generateUrl({
                                data: {
                                    key: name,
                                    value: value
                                }
                            });
                            history.pushState(null, "", newUrl);
                            // check if there is an image to update, e.g. gold color icons
                            var newImage = radioButton.dataset.img;
                            if (optionImage && newImage) optionImage.src = newImage;
                        });
                        radioButton.addEventListener("click", function() {
                            // remove no-selection-made class
                            optionList.classList.remove("no-selection-made");
                        });
                    });
                });
                window.addEventListener("popstate", this.onHistoryChange.bind(this));
            }
        },
        {
            key: "generateUrl",
            value: function generateUrl(param) {
                var data = param.data;
                var key = data.key, value = data.value;
                // start with empty params
                var params = {
                    variant: "",
                    "gold-color": "",
                    "ring-size": ""
                };
                // get current params
                var currentParams = new URLSearchParams(window.location.search);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // loop through current params and set new params
                    for(var _iterator = currentParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $5ZV7E._)(_step.value, 2), key1 = _step_value[0], value1 = _step_value[1];
                        params[key1] = value1;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // set new value
                params[key] = value;
                // normalize params
                if (params.variant === "") delete params.variant;
                if (params["gold-color"] === "") delete params["gold-color"];
                if (params["ring-size"] === "") delete params["ring-size"];
                // build new search string
                var queryString = this.toQueryString(params);
                return queryString;
            }
        },
        {
            key: "renderPage",
            value: function renderPage(param) {
                var _this = this;
                var url = param.url, _param_updateOptions = param.updateOptions, updateOptions = _param_updateOptions === void 0 ? false : _param_updateOptions;
                fetch(url).then(function(response) {
                    return response.text();
                }).then(function(html) {
                    var resultsMarkup = new DOMParser().parseFromString(html, "text/html");
                    // get new price text and replace current price text
                    var newPriceText = resultsMarkup.querySelector("#price-text");
                    _this.priceText.innerHTML = newPriceText.innerHTML;
                    // update affirm text
                    _this.affirmText.setAttribute("data-amount", parseInt(newPriceText.dataset.price));
                    affirm.ui.refresh();
                    // get new variant id and replace
                    var newVariantId = resultsMarkup.querySelector("#current_variant_id");
                    _this.currentVariantId.value = newVariantId.value;
                    // get new option lists
                    var newOptions = Array.from(resultsMarkup.querySelectorAll('.option-list.dynamic-option input[type="radio"]'));
                    newOptions.forEach(function(newOption) {
                        var id = newOption.id;
                        var oldRadioButton = document.getElementById(id);
                        // change checked value
                        if (updateOptions) oldRadioButton.checked = newOption.checked;
                        // change variant id values
                        if (newOption.dataset.variantId !== oldRadioButton.dataset.variantId) oldRadioButton.dataset.variantId = newOption.dataset.variantId;
                    });
                    if (updateOptions) {
                        var newSelectedDynamicItems = Array.from(resultsMarkup.querySelectorAll(".option-list.dynamic-option .selected-item"));
                        newSelectedDynamicItems.forEach(function(newSelectedItem) {
                            var id = newSelectedItem.id;
                            var oldSelectedItem = document.getElementById(id);
                            oldSelectedItem.innerHTML = newSelectedItem.innerHTML;
                        });
                    }
                    _this.productInfo.classList.remove("loading");
                });
            }
        },
        {
            key: "updateStaticOptions",
            value: function updateStaticOptions() {
                var addInitializedClass = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var searchParams = new URLSearchParams(window.location.search);
                // check if there is an element in static option lists that has data-name of 'Gold Color'
                var goldColorOption = this.staticOptionLists.find(function(option) {
                    return option.dataset.name === "Gold Color";
                });
                var ringSizeOption = this.staticOptionLists.find(function(option) {
                    return option.dataset.name === "Ring Size";
                });
                if (goldColorOption) this.staticOptionUpdate({
                    title: "Gold Color",
                    searchParams: searchParams,
                    addInitializedClass: addInitializedClass
                });
                if (ringSizeOption) this.staticOptionUpdate({
                    title: "Ring Size",
                    searchParams: searchParams,
                    addInitializedClass: addInitializedClass
                });
            }
        },
        {
            key: "staticOptionUpdate",
            value: function staticOptionUpdate(param) {
                var title = param.title, searchParams = param.searchParams, addInitializedClass = param.addInitializedClass;
                var slug = (0, (/*@__PURE__*/$parcel$interopDefault($hN5jq)))(title, {
                    lower: true
                });
                var paramVal = searchParams.get(slug);
                // get radio buttons
                var radios = Array.from(document.querySelectorAll('input[name="static-option:'.concat(title, '"]')));
                if (paramVal) radios.forEach(function(radio) {
                    if (radio.id === "".concat(slug, "-").concat(paramVal)) radio.checked = true;
                });
                // get selected item
                var optionList = document.querySelector('.option-list:not(.dynamic-option)[data-name="'.concat(title, '"]'));
                var selectedItem = optionList.querySelector(".selected-item");
                if (selectedItem && paramVal) selectedItem.innerHTML = radios.find(function(radio) {
                    return radio.checked;
                }).value;
                if (addInitializedClass) {
                    optionList.classList.add("initialized");
                    optionList.classList.remove("no-selection-made");
                }
            }
        },
        {
            key: "onHistoryChange",
            value: function onHistoryChange() {
                var variantId = new URLSearchParams(window.location.search).get("variant");
                var sectionUrl = "".concat(window.location.pathname, "?section_id=main-product").concat(variantId ? "&variant=".concat(variantId) : "");
                this.renderPage({
                    url: sectionUrl,
                    updateOptions: true
                });
                if (this.staticOptionLists.length) this.updateStaticOptions();
            }
        },
        {
            key: "toQueryString",
            value: function toQueryString(obj) {
                var queryString = Object.keys(obj).map(function(key) {
                    var value = obj[key];
                    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
                }).join("&").replace(/%20/g, "+"); // Wordpress style '+' separator
                return queryString ? "?" + queryString : "";
            }
        }
    ]);
    return VariantPicker;
}((0, $f2oEI._)(HTMLElement));

});
parcelRegister("J7ygF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $087a0fb22a93b2d1$export$71511d61b312f219; });
function $087a0fb22a93b2d1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hvJJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbf8ce221d4c5514$export$71511d61b312f219; });
function $cbf8ce221d4c5514$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbf8ce221d4c5514$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("6CdNF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4d10ff170fc484d8$export$71511d61b312f219; });

var $cQvOp = parcelRequire("cQvOp");
function $4d10ff170fc484d8$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $cQvOp._)(subClass, superClass);
}

});
parcelRegister("cQvOp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $95a30497252ae948$export$71511d61b312f219; });
function $95a30497252ae948$export$71511d61b312f219(o, p) {
    $95a30497252ae948$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $95a30497252ae948$export$71511d61b312f219(o, p);
}

});


parcelRegister("5ZV7E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $45def593611ffc53$export$71511d61b312f219; });

var $dakGr = parcelRequire("dakGr");

var $3iELS = parcelRequire("3iELS");

var $lbIZx = parcelRequire("lbIZx");

var $6HNFp = parcelRequire("6HNFp");
function $45def593611ffc53$export$71511d61b312f219(arr, i) {
    return (0, $dakGr._)(arr) || (0, $3iELS._)(arr, i) || (0, $6HNFp._)(arr, i) || (0, $lbIZx._)();
}

});
parcelRegister("dakGr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $995c40d652b0553f$export$71511d61b312f219; });
function $995c40d652b0553f$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("3iELS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2672addbd595e189$export$71511d61b312f219; });
function $2672addbd595e189$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("lbIZx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f6cd8669e12714d8$export$71511d61b312f219; });
function $f6cd8669e12714d8$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("6HNFp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4e1d490ad7b9bee1$export$71511d61b312f219; });

var $84Wdk = parcelRequire("84Wdk");
function $4e1d490ad7b9bee1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $84Wdk._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $84Wdk._)(o, minLen);
}

});
parcelRegister("84Wdk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5e1bda8aa9cfef6d$export$71511d61b312f219; });
function $5e1bda8aa9cfef6d$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("f2oEI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $af2a2b044a0a409b$export$71511d61b312f219; });

var $gLC2R = parcelRequire("gLC2R");

var $kW6rP = parcelRequire("kW6rP");

var $jDxPN = parcelRequire("jDxPN");

var $cQvOp = parcelRequire("cQvOp");
function $af2a2b044a0a409b$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $af2a2b044a0a409b$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $jDxPN._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $gLC2R._)(Class, arguments, (0, $kW6rP._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $cQvOp._)(Wrapper, Class);
    };
    return $af2a2b044a0a409b$export$71511d61b312f219(Class);
}

});
parcelRegister("gLC2R", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c34e8c1ad92e968a$export$71511d61b312f219; });

var $dT0gu = parcelRequire("dT0gu");

var $cQvOp = parcelRequire("cQvOp");
function $c34e8c1ad92e968a$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $dT0gu._)()) $c34e8c1ad92e968a$export$71511d61b312f219 = Reflect.construct;
    else $c34e8c1ad92e968a$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $cQvOp._)(instance, Class.prototype);
        return instance;
    };
    return $c34e8c1ad92e968a$export$71511d61b312f219.apply(null, arguments);
}

});
parcelRegister("dT0gu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a1c09e075e482dd9$export$71511d61b312f219; });
function $a1c09e075e482dd9$export$71511d61b312f219() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("kW6rP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f3de39cf8026604e$export$71511d61b312f219; });
function $f3de39cf8026604e$export$71511d61b312f219(o) {
    $f3de39cf8026604e$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f3de39cf8026604e$export$71511d61b312f219(o);
}

});

parcelRegister("jDxPN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e4bbe7ac69c9ab68$export$71511d61b312f219; });
function $e4bbe7ac69c9ab68$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("3eaZI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $259b352671629a5e$export$71511d61b312f219; });

var $kW6rP = parcelRequire("kW6rP");

var $dT0gu = parcelRequire("dT0gu");

var $1d9ZF = parcelRequire("1d9ZF");
function $259b352671629a5e$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = (0, $dT0gu._)();
    return function _createSuperInternal() {
        var Super = (0, $kW6rP._)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $kW6rP._)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $1d9ZF._)(this, result);
    };
}

});
parcelRegister("1d9ZF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0e1ec1de7b164f64$export$71511d61b312f219; });

var $esf5j = parcelRequire("esf5j");

var $5euqn = parcelRequire("5euqn");
function $0e1ec1de7b164f64$export$71511d61b312f219(self, call) {
    if (call && ((0, $5euqn._)(call) === "object" || typeof call === "function")) return call;
    return (0, $esf5j._)(self);
}

});
parcelRegister("esf5j", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a85f61b7cff42eb9$export$71511d61b312f219; });
function $a85f61b7cff42eb9$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("5euqn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3cf5dc3c2ce8e525$export$71511d61b312f219; });
function $3cf5dc3c2ce8e525$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("hN5jq", function(module, exports) {
(function(name, root, factory) {
    module.exports = factory();
    module.exports["default"] = factory();
})("slugify", module.exports, function() {
    var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","\xa2":"cent","\xa3":"pound","\xa4":"currency","\xa5":"yen","\xa9":"(c)","\xaa":"a","\xae":"(r)","\xba":"o","\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xc6":"AE","\xc7":"C","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xd0":"D","\xd1":"N","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xdd":"Y","\xde":"TH","\xdf":"ss","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xe6":"ae","\xe7":"c","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xf0":"d","\xf1":"n","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xfd":"y","\xfe":"th","\xff":"y","\u0100":"A","\u0101":"a","\u0102":"A","\u0103":"a","\u0104":"A","\u0105":"a","\u0106":"C","\u0107":"c","\u010C":"C","\u010D":"c","\u010E":"D","\u010F":"d","\u0110":"DJ","\u0111":"dj","\u0112":"E","\u0113":"e","\u0116":"E","\u0117":"e","\u0118":"e","\u0119":"e","\u011A":"E","\u011B":"e","\u011E":"G","\u011F":"g","\u0122":"G","\u0123":"g","\u0128":"I","\u0129":"i","\u012A":"i","\u012B":"i","\u012E":"I","\u012F":"i","\u0130":"I","\u0131":"i","\u0136":"k","\u0137":"k","\u013B":"L","\u013C":"l","\u013D":"L","\u013E":"l","\u0141":"L","\u0142":"l","\u0143":"N","\u0144":"n","\u0145":"N","\u0146":"n","\u0147":"N","\u0148":"n","\u014C":"O","\u014D":"o","\u0150":"O","\u0151":"o","\u0152":"OE","\u0153":"oe","\u0154":"R","\u0155":"r","\u0158":"R","\u0159":"r","\u015A":"S","\u015B":"s","\u015E":"S","\u015F":"s","\u0160":"S","\u0161":"s","\u0162":"T","\u0163":"t","\u0164":"T","\u0165":"t","\u0168":"U","\u0169":"u","\u016A":"u","\u016B":"u","\u016E":"U","\u016F":"u","\u0170":"U","\u0171":"u","\u0172":"U","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017A":"z","\u017B":"Z","\u017C":"z","\u017D":"Z","\u017E":"z","\u018F":"E","\u0192":"f","\u01A0":"O","\u01A1":"o","\u01AF":"U","\u01B0":"u","\u01C8":"LJ","\u01C9":"lj","\u01CB":"NJ","\u01CC":"nj","\u0218":"S","\u0219":"s","\u021A":"T","\u021B":"t","\u0259":"e","\u02DA":"o","\u0386":"A","\u0388":"E","\u0389":"H","\u038A":"I","\u038C":"O","\u038E":"Y","\u038F":"W","\u0390":"i","\u0391":"A","\u0392":"B","\u0393":"G","\u0394":"D","\u0395":"E","\u0396":"Z","\u0397":"H","\u0398":"8","\u0399":"I","\u039A":"K","\u039B":"L","\u039C":"M","\u039D":"N","\u039E":"3","\u039F":"O","\u03A0":"P","\u03A1":"R","\u03A3":"S","\u03A4":"T","\u03A5":"Y","\u03A6":"F","\u03A7":"X","\u03A8":"PS","\u03A9":"W","\u03AA":"I","\u03AB":"Y","\u03AC":"a","\u03AD":"e","\u03AE":"h","\u03AF":"i","\u03B0":"y","\u03B1":"a","\u03B2":"b","\u03B3":"g","\u03B4":"d","\u03B5":"e","\u03B6":"z","\u03B7":"h","\u03B8":"8","\u03B9":"i","\u03BA":"k","\u03BB":"l","\u03BC":"m","\u03BD":"n","\u03BE":"3","\u03BF":"o","\u03C0":"p","\u03C1":"r","\u03C2":"s","\u03C3":"s","\u03C4":"t","\u03C5":"y","\u03C6":"f","\u03C7":"x","\u03C8":"ps","\u03C9":"w","\u03CA":"i","\u03CB":"y","\u03CC":"o","\u03CD":"y","\u03CE":"w","\u0401":"Yo","\u0402":"DJ","\u0404":"Ye","\u0406":"I","\u0407":"Yi","\u0408":"J","\u0409":"LJ","\u040A":"NJ","\u040B":"C","\u040F":"DZ","\u0410":"A","\u0411":"B","\u0412":"V","\u0413":"G","\u0414":"D","\u0415":"E","\u0416":"Zh","\u0417":"Z","\u0418":"I","\u0419":"J","\u041A":"K","\u041B":"L","\u041C":"M","\u041D":"N","\u041E":"O","\u041F":"P","\u0420":"R","\u0421":"S","\u0422":"T","\u0423":"U","\u0424":"F","\u0425":"H","\u0426":"C","\u0427":"Ch","\u0428":"Sh","\u0429":"Sh","\u042A":"U","\u042B":"Y","\u042C":"","\u042D":"E","\u042E":"Yu","\u042F":"Ya","\u0430":"a","\u0431":"b","\u0432":"v","\u0433":"g","\u0434":"d","\u0435":"e","\u0436":"zh","\u0437":"z","\u0438":"i","\u0439":"j","\u043A":"k","\u043B":"l","\u043C":"m","\u043D":"n","\u043E":"o","\u043F":"p","\u0440":"r","\u0441":"s","\u0442":"t","\u0443":"u","\u0444":"f","\u0445":"h","\u0446":"c","\u0447":"ch","\u0448":"sh","\u0449":"sh","\u044A":"u","\u044B":"y","\u044C":"","\u044D":"e","\u044E":"yu","\u044F":"ya","\u0451":"yo","\u0452":"dj","\u0454":"ye","\u0456":"i","\u0457":"yi","\u0458":"j","\u0459":"lj","\u045A":"nj","\u045B":"c","\u045D":"u","\u045F":"dz","\u0490":"G","\u0491":"g","\u0492":"GH","\u0493":"gh","\u049A":"KH","\u049B":"kh","\u04A2":"NG","\u04A3":"ng","\u04AE":"UE","\u04AF":"ue","\u04B0":"U","\u04B1":"u","\u04BA":"H","\u04BB":"h","\u04D8":"AE","\u04D9":"ae","\u04E8":"OE","\u04E9":"oe","\u0531":"A","\u0532":"B","\u0533":"G","\u0534":"D","\u0535":"E","\u0536":"Z","\u0537":"E\'","\u0538":"Y\'","\u0539":"T\'","\u053A":"JH","\u053B":"I","\u053C":"L","\u053D":"X","\u053E":"C\'","\u053F":"K","\u0540":"H","\u0541":"D\'","\u0542":"GH","\u0543":"TW","\u0544":"M","\u0545":"Y","\u0546":"N","\u0547":"SH","\u0549":"CH","\u054A":"P","\u054B":"J","\u054C":"R\'","\u054D":"S","\u054E":"V","\u054F":"T","\u0550":"R","\u0551":"C","\u0553":"P\'","\u0554":"Q\'","\u0555":"O\'\'","\u0556":"F","\u0587":"EV","\u0621":"a","\u0622":"aa","\u0623":"a","\u0624":"u","\u0625":"i","\u0626":"e","\u0627":"a","\u0628":"b","\u0629":"h","\u062A":"t","\u062B":"th","\u062C":"j","\u062D":"h","\u062E":"kh","\u062F":"d","\u0630":"th","\u0631":"r","\u0632":"z","\u0633":"s","\u0634":"sh","\u0635":"s","\u0636":"dh","\u0637":"t","\u0638":"z","\u0639":"a","\u063A":"gh","\u0641":"f","\u0642":"q","\u0643":"k","\u0644":"l","\u0645":"m","\u0646":"n","\u0647":"h","\u0648":"w","\u0649":"a","\u064A":"y","\u064B":"an","\u064C":"on","\u064D":"en","\u064E":"a","\u064F":"u","\u0650":"e","\u0652":"","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u067E":"p","\u0686":"ch","\u0698":"zh","\u06A9":"k","\u06AF":"g","\u06CC":"y","\u06F0":"0","\u06F1":"1","\u06F2":"2","\u06F3":"3","\u06F4":"4","\u06F5":"5","\u06F6":"6","\u06F7":"7","\u06F8":"8","\u06F9":"9","\u0E3F":"baht","\u10D0":"a","\u10D1":"b","\u10D2":"g","\u10D3":"d","\u10D4":"e","\u10D5":"v","\u10D6":"z","\u10D7":"t","\u10D8":"i","\u10D9":"k","\u10DA":"l","\u10DB":"m","\u10DC":"n","\u10DD":"o","\u10DE":"p","\u10DF":"zh","\u10E0":"r","\u10E1":"s","\u10E2":"t","\u10E3":"u","\u10E4":"f","\u10E5":"k","\u10E6":"gh","\u10E7":"q","\u10E8":"sh","\u10E9":"ch","\u10EA":"ts","\u10EB":"dz","\u10EC":"ts","\u10ED":"ch","\u10EE":"kh","\u10EF":"j","\u10F0":"h","\u1E62":"S","\u1E63":"s","\u1E80":"W","\u1E81":"w","\u1E82":"W","\u1E83":"w","\u1E84":"W","\u1E85":"w","\u1E9E":"SS","\u1EA0":"A","\u1EA1":"a","\u1EA2":"A","\u1EA3":"a","\u1EA4":"A","\u1EA5":"a","\u1EA6":"A","\u1EA7":"a","\u1EA8":"A","\u1EA9":"a","\u1EAA":"A","\u1EAB":"a","\u1EAC":"A","\u1EAD":"a","\u1EAE":"A","\u1EAF":"a","\u1EB0":"A","\u1EB1":"a","\u1EB2":"A","\u1EB3":"a","\u1EB4":"A","\u1EB5":"a","\u1EB6":"A","\u1EB7":"a","\u1EB8":"E","\u1EB9":"e","\u1EBA":"E","\u1EBB":"e","\u1EBC":"E","\u1EBD":"e","\u1EBE":"E","\u1EBF":"e","\u1EC0":"E","\u1EC1":"e","\u1EC2":"E","\u1EC3":"e","\u1EC4":"E","\u1EC5":"e","\u1EC6":"E","\u1EC7":"e","\u1EC8":"I","\u1EC9":"i","\u1ECA":"I","\u1ECB":"i","\u1ECC":"O","\u1ECD":"o","\u1ECE":"O","\u1ECF":"o","\u1ED0":"O","\u1ED1":"o","\u1ED2":"O","\u1ED3":"o","\u1ED4":"O","\u1ED5":"o","\u1ED6":"O","\u1ED7":"o","\u1ED8":"O","\u1ED9":"o","\u1EDA":"O","\u1EDB":"o","\u1EDC":"O","\u1EDD":"o","\u1EDE":"O","\u1EDF":"o","\u1EE0":"O","\u1EE1":"o","\u1EE2":"O","\u1EE3":"o","\u1EE4":"U","\u1EE5":"u","\u1EE6":"U","\u1EE7":"u","\u1EE8":"U","\u1EE9":"u","\u1EEA":"U","\u1EEB":"u","\u1EEC":"U","\u1EED":"u","\u1EEE":"U","\u1EEF":"u","\u1EF0":"U","\u1EF1":"u","\u1EF2":"Y","\u1EF3":"y","\u1EF4":"Y","\u1EF5":"y","\u1EF6":"Y","\u1EF7":"y","\u1EF8":"Y","\u1EF9":"y","\u2013":"-","\u2018":"\'","\u2019":"\'","\u201C":"\\"","\u201D":"\\"","\u201E":"\\"","\u2020":"+","\u2022":"*","\u2026":"...","\u20A0":"ecu","\u20A2":"cruzeiro","\u20A3":"french franc","\u20A4":"lira","\u20A5":"mill","\u20A6":"naira","\u20A7":"peseta","\u20A8":"rupee","\u20A9":"won","\u20AA":"new shequel","\u20AB":"dong","\u20AC":"euro","\u20AD":"kip","\u20AE":"tugrik","\u20AF":"drachma","\u20B0":"penny","\u20B1":"peso","\u20B2":"guarani","\u20B3":"austral","\u20B4":"hryvnia","\u20B5":"cedi","\u20B8":"kazakhstani tenge","\u20B9":"indian rupee","\u20BA":"turkish lira","\u20BD":"russian ruble","\u20BF":"bitcoin","\u2120":"sm","\u2122":"tm","\u2202":"d","\u2206":"delta","\u2211":"sum","\u221E":"infinity","\u2665":"love","\u5143":"yuan","\u5186":"yen","\uFDFC":"rial","\uFEF5":"laa","\uFEF7":"laa","\uFEF9":"lai","\uFEFB":"la"}');
    var locales = JSON.parse('{"bg":{"\u0419":"Y","\u0426":"Ts","\u0429":"Sht","\u042A":"A","\u042C":"Y","\u0439":"y","\u0446":"ts","\u0449":"sht","\u044A":"a","\u044C":"y"},"de":{"\xc4":"AE","\xe4":"ae","\xd6":"OE","\xf6":"oe","\xdc":"UE","\xfc":"ue","\xdf":"ss","%":"prozent","&":"und","|":"oder","\u2211":"summe","\u221E":"unendlich","\u2665":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","\xa2":"centavos","\xa3":"libras","\xa4":"moneda","\u20A3":"francos","\u2211":"suma","\u221E":"infinito","\u2665":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","\xa2":"centime","\xa3":"livre","\xa4":"devise","\u20A3":"franc","\u2211":"somme","\u221E":"infini","\u2665":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","\xa2":"centavo","\u2211":"soma","\xa3":"libra","\u221E":"infinito","\u2665":"amor"},"uk":{"\u0418":"Y","\u0438":"y","\u0419":"Y","\u0439":"y","\u0426":"Ts","\u0446":"ts","\u0425":"Kh","\u0445":"kh","\u0429":"Shch","\u0449":"shch","\u0413":"H","\u0433":"h"},"vi":{"\u0110":"D","\u0111":"d"},"da":{"\xd8":"OE","\xf8":"oe","\xc5":"AA","\xe5":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"st\xf8rre end"},"nb":{"&":"og","\xc5":"AA","\xc6":"AE","\xd8":"OE","\xe5":"aa","\xe6":"ae","\xf8":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","\xc5":"AA","\xc4":"AE","\xd6":"OE","\xe5":"aa","\xe4":"ae","\xf6":"oe"}}');
    function replace(string, options) {
        if (typeof string !== "string") throw new Error("slugify: string argument expected");
        options = typeof options === "string" ? {
            replacement: options
        } : options || {};
        var locale = locales[options.locale] || {};
        var replacement = options.replacement === undefined ? "-" : options.replacement;
        var trim = options.trim === undefined ? true : options.trim;
        var slug = string.normalize().split("")// replace characters based on charMap
        .reduce(function(result, ch) {
            var appendChar = locale[ch];
            if (appendChar === undefined) appendChar = charMap[ch];
            if (appendChar === undefined) appendChar = ch;
            if (appendChar === replacement) appendChar = " ";
            return result + appendChar// remove not allowed characters
            .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
        if (options.strict) slug = slug.replace(/[^A-Za-z0-9\s]/g, "");
        if (trim) slug = slug.trim();
        // Replace spaces with replacement character, treating multiple consecutive
        // spaces as a single space.
        slug = slug.replace(/\s+/g, replacement);
        if (options.lower) slug = slug.toLowerCase();
        return slug;
    }
    replace.extend = function(customMap) {
        Object.assign(charMap, customMap);
    };
    return replace;
});

});


})();
//# sourceMappingURL=VariantPicker.97f344bc.js.map
